import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fetch-more-button-container"
}
const _hoisted_2 = {
  key: 1,
  class: "busy-indicator-container"
}

import isNil from 'lodash/isNil'
import { computed, onBeforeMount, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import BusyIndicator from '@/components/common/BusyIndicator.vue'
import FormButton from '@/components/common/FormButton.vue'
import TableWithStickyHeader, {
  TableColumn,
} from '@/components/common/TableWithStickyHeader.vue'
import i18n from '@/i18n'
import { useBowlerStore } from '@/store/bowler-app/bowler'
import { useBowlerSeriesScoresStore } from '@/store/bowler-app/bowler-series-scores'
import { getErrorMessage } from '@/utils/error-handling'
import { formatDate, formatFloat, formatValue } from '@/utils/format'


export default /*@__PURE__*/_defineComponent({
  __name: 'BowlerResultsView',
  setup(__props) {

const bowler = useBowlerStore()
const bowlerScores = useBowlerSeriesScoresStore()
const router = useRouter()

const errorMessage = ref<string | null>()
const isLoading = ref<boolean>(false)

const scoreTableColumns = computed<TableColumn[]>((): TableColumn[] => [
  { label: i18n.global.t('bowler-scores.date'), type: 'value' },
  { label: i18n.global.t('bowler-scores.bowling-alley'), type: '' },
  { label: i18n.global.t('bowler-scores.competitions'), type: 'wide' },
  { label: i18n.global.t('bowler-scores.score'), type: 'value' },
  { label: i18n.global.t('bowler-scores.game-count'), type: 'value-wide' },
  { label: i18n.global.t('bowler-scores.average'), type: 'value-wide' },
])

const scoreTableData = computed<string[][]>((): string[][] =>
  bowlerScores.scores.map((score) => [
    formatDate(score.date, false, true),
    formatValue(score.bowlingAlley),
    formatValue(score.competitions?.join(' · ')),
    formatFloat(score.score, 0),
    formatFloat(score.gameCount, 0),
    formatFloat(score.gameAverage, 2),
  ]),
)

const fetchScores = async (isFirstFetch = false): Promise<void> => {
  isLoading.value = true

  try {
    isFirstFetch
      ? await bowlerScores.fetch(bowler.id as number)
      : await bowlerScores.fetchNext()
  } catch (e) {
    const message = getErrorMessage(e as Error)
    console.error(
      `Failed fetching scores for the bowler with ID ${bowler.id}: ${message}`,
    )
    errorMessage.value = message
  }

  isLoading.value = false
}

const fetchMoreScores = async (): Promise<void> => fetchScores(false)

/* hooks */

onBeforeMount(async (): Promise<void> => {
  if (isNil(bowler.id)) {
    await router.replace({ path: '/' })
  }
})

onMounted(async (): Promise<void> => fetchScores(true))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('section-titles.results')), 1),
    _createVNode(TableWithStickyHeader, {
      columns: scoreTableColumns.value,
      data: scoreTableData.value
    }, null, 8, ["columns", "data"]),
    (!isLoading.value && _unref(bowlerScores).nextUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(FormButton, {
            onClick: _withModifiers(fetchMoreScores, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('bowler-scores.fetch-more')), 1)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, [
          _createVNode(BusyIndicator)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})